export const config = {
  server: '',
  projectName: '',
  serverForResetPassword: '',
  shouldDisplayLogoAsProjectName: '',
  useCustomHtml: false,
  redirectUrlAfterEmailVerification: {
    success: {
      desktop: '',
      mobile: ''
    },
    failure: {
      desktop: '',
      mobile: ''
    }
  },
  theme: {
    background: '',
    headerBackgroundColor: '',
    projectNameStyle: {},
    saveButtonStyle: {},
    saveButtonDisableStyle: {},
    saveButtonPressedStyle: {},
    saveButtonLabel: {},
    saveButtonLabelEnabled: {},
    inputFloatingLabel: {},
    inputErrorStyle: {},
    inputUnderlineFocus: {},
    inputFloutingLabelFocus: {},
    inputStyle: {},
    spinnerColor: '',
    informPageTitle: {},
    informPageText: {},
    formErrorText: {},
    formTitle: {},
    iconColor: '',
    iconFill: ''
  },
};

export const initConfig = function(settings) {
  config.server = settings.server;
  config.serverForResetPassword = settings.serverForResetPassword || '';
  config.projectName = settings.projectName;
  config.shouldDisplayLogoAsProjectName = settings.shouldDisplayLogoAsProjectName;
  config.redirectUrlAfterEmailVerification = settings.redirectUrlAfterEmailVerification;
  config.useCustomHtml = settings.useCustomHtml;
  config.theme = settings.theme;
};
